import React from 'react';
import {PropTypes} from 'prop-types';
import { CreateTimer, FormatDiffAsDuration } from '../../shared/utils';
import moment from 'moment-timezone';

export class DurationComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.refreshTimer = CreateTimer(props.refreshInterval);
        this.updateTimerState = this.updateTimerState.bind(this);
    }

    updateTimerState() {
        const self = this;

        if (Boolean(self.refreshTimer)) {
            const {refreshInterval, finishedAt} = self.props;
            self.refreshTimer.interval = refreshInterval;
            self.refreshTimer.isActive = self._isMounted && !Boolean(finishedAt);
        }
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;
        self.refreshTimer.onTimer = () => {
            if (self._isMounted) {
                self.refreshTimer.stop();
                self.forceUpdate(self.updateTimerState);
            }
            else {
                return true;
            }
        }
        self.updateTimerState();
    }

    componentWillUnmount() {
        const self = this;
        self._isMounted = false;

        if (Boolean(self.refreshTimer)) {
            self.refreshTimer.stop();
            self.refreshTimer.onTimer = null;
            self.refreshTimer = null;
        }
    }

    componentDidUpdate() {
        this.updateTimerState();
    }

    render() {
        const self = this;
        let {startedAt, finishedAt, displayMilliseconds, displayHours, displayMinutes} = self.props;

        if (!Boolean(finishedAt)) {
            finishedAt = moment.utc();
        }
        
        const isValid = moment(startedAt).isValid() && moment(finishedAt).isValid();

        if (!isValid) {
            return "invalid value";
        }

        const diff = moment.utc(finishedAt).diff(moment.utc(startedAt));
        const result = FormatDiffAsDuration(
            diff, 
            {
                addMilliseconds: displayMilliseconds, 
                truncateHours: !Boolean(displayHours), 
                truncateMinutes: !Boolean(displayMinutes)
            });

        return result;
    }
}
DurationComponent.propTypes = {
    refreshInterval: PropTypes.number.isRequired,
    displayMilliseconds: PropTypes.bool,
    displayHours: PropTypes.bool,
    displayMinutes: PropTypes.bool,
}
DurationComponent.defaultProps = {
    refreshInterval: 1000,
    displayMilliseconds: false,
    displayHours: true,
    displayMinutes: true,
}